import type { LegacyRiskGapStatus, RiskGapModel } from '@ctw/shared/api/fhir/models/risk-gap';

export const isOpenGap = (status: LegacyRiskGapStatus) => status === 'open-gap';

export function buildRiskGapTelemetryContext(
  riskGap: RiskGapModel,
  options?: { evidenceCount?: number },
) {
  return {
    riskGapType: riskGap.type,
    riskGapStatus: riskGap.status,
    riskGapConfidenceRating: riskGap.confidenceRating,
    riskGapEvidenceCount: options?.evidenceCount,
  };
}
